
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Plus, Minus } from "lucide-react";

interface ParcelQuantityFieldProps {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
}

const ParcelQuantityField: React.FC<ParcelQuantityFieldProps> = ({
  quantity,
  onQuantityChange
}) => {
  return (
    <div className="flex justify-end">
      <div className="space-y-2">
        <Label>Quantity</Label>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onQuantityChange(Math.max(1, quantity - 1))}
            disabled={quantity <= 1}
          >
            <Minus className="h-4 w-4" />
          </Button>
          <Input
            type="number"
            value={quantity}
            onChange={(e) => onQuantityChange(Math.max(1, parseInt(e.target.value) || 1))}
            className="w-20 text-center"
            min="1"
          />
          <Button
            variant="outline"
            size="sm"
            onClick={() => onQuantityChange(quantity + 1)}
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ParcelQuantityField;
